<template>
  <v-app-bar height="56" color="surface" dense app flat outlined elevate-on-scroll>
    <nav-menu />
    <div class="ml-8">
      <select2 dark v-if="current_workspace" flat solo dense
        style="min-height: 40px; height: 40px; width: 222px; border-radius: 5px;" hide-details height="40px"
        v-model="current_workspace" :items="workspaces" item-text="name" return-object min-height="40px" item-value="id"
        :menu-props="{ maxWidth: 280, Width: 280 }" @input="redirect">
        <template v-slot:prepend-item>
          <v-list-item ripple class="mt-2" @click="callBack">
            <v-list-item-content>
              <v-list-item-title>All workspaces</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
        <template v-slot:append>
          <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.93265 10L13.4767 15L19.0207 10" :stroke="primaryColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </template>
      </select2>
    </div>
    <v-spacer></v-spacer>
    <!-- <search-full-input /> -->
    <span style="margin-right: 34px" v-if="userProfile">
      <strong
        style="font-style: normal;font-weight: normal;font-size: 16px;line-height: 18px;text-align: right;">EOToken:
      </strong>
      <strong :class="parseInt(userProfile.token_amount) < 500 ? 'error--text' : 'accent--text'">
        {{ comaFormat(userProfile.token_amount) }}
      </strong>
    </span>
    <notification style="margin-right: 28px;"></notification>
    <user-profile></user-profile>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Notification from '@components/notification/notification'
import UserProfile from '@components/user-profile'
import NavMenu from '@/components/layout/nav-menu'
import numberFormat from '@utils/Comma'
import Select2 from '@/components/common/Select2'

export default {
  data() {
    return {
      current_workspace: undefined,
      items: []
    }
  },
  computed: {
    ...mapGetters('region', ['regions']),
    ...mapGetters('auth', ['loggedIn', 'userProfile']),
    ...mapGetters('workspace', ['workspaces']),
    primaryColor() {
      return this.$vuetify.theme.dark ? this.$vuetify.theme.themes.light.primary : this.$vuetify.theme.themes.dark.primary
    }
  },
  components: {
    Select2,
    UserProfile,
    Notification,
    NavMenu
  },
  methods: {
    ...mapActions('workspace', ['fetchWorkspace']),
    ...mapActions('imagery', ['updateUser']),
    applyChangeRegion() {
      this.updateUser({ region_id: this.userProfile.region.id })
        .then(res => {
          this.$snackbar.showSuccess(res.data.message)
          window.location.href = '/aetos-ai/workspaces'
        })
        .catch(er => {
          this.$snackbar.showError(er.message)
        })
        .finally(() => {
          this.isEditRegion = true
        })
    },
    comaFormat(number) {
      return numberFormat.numberWithCommas(number)
    },
    home() {
      this.$router.push('/workspaces')
    },
    callBack() {
      this.$router.replace({ name: 'workspaces' }).catch(_ => { })
    },
    redirect(item) {
      window.location.href = '/aetos-ai/workspaces/' + item.id
    },
    onTicketClick() {
      if (this.userProfile.user_group === 'admin') {
        this.$router.push('/ticket-management')
      } else {
        this.$router.push('/ticket')
      }
    }
  },
  created() {
    if (this.userProfile && this.loggedIn && !this.workspaces.length && this.userProfile.region) {
      this.fetchWorkspace()
    }
  },
  mounted() {
    if (this.$route.name === 'wks') {
      this.current_workspace = this.$route.params.id
    }
  }
}
</script>

<style scoped>
.v-input__control {
  min-height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/nav-bar.vue